import React from 'react';
import { Button } from 'chic-ui';
import { Row } from 'react-bootstrap';
import { BiWine } from 'react-icons/bi';

const Icon = () => {
  return (
    <>
      <h4 className="mt-5">Icons</h4>
      <p>
        Icons can be used within the buttons either by using <i>icon </i>
        prop or as <i>children.</i>
      </p>
      <div className="btn-group btns mt-3">
        <Button className="single-btn" icon={BiWine} type="light">
          More wine!
        </Button>
        <Button className="single-btn">
          No wine! <BiWine color="white" />
        </Button>
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Button } from "chic-ui";'}
          <br />
          {'<Button icon={BiWine} type="light">More wine!</Button>'}
          <br />
          {'<Button>No wine! <BiWine /></Button>'}
        </code>
      </Row>
    </>
  );
};

export default Icon;
